import { Pagination, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import FixMenu from '@/components/FixMenu/FixMenu';
import { POLICY_LEVEL, policyType } from '@/utils/mappingDict';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getPolicy } from '@/services/policy';
import FilterType from '@/components/FilterType/FilterType';
import { getDictType } from '@/services/common';
import './index.less';

export default function Index() {
  const Navigate = useNavigate();
  const [val, setVal] = useState({});

  const { data: dict = {} } = useRequest(getDictType, { // 筛选项字典
    defaultParams: [POLICY_LEVEL],
  });

  const { data, loading, run } = useRequest(getPolicy);

  const onPageChange = (pageNum) => {
    run({ pageNum, ...val });
  };

  function handleChange(id) {
    Navigate(`/notice/detail?id=${id}`);
  }

  function getData(date, type) {
    const year = date?.split('-');
    if (type === 'day') {
      return `${year?.[2]}`;
    }
    return `${year?.[0]}-${year?.[1]}`;
  }

  const handleFilter = (arr, type) => {
    const target = isEmpty(arr) ? undefined : arr[0];
    setVal({ ...val, [type]: target });
    run({ [type]: target });
  };

  return (
    <div className="zczx">
      <div className="zczx__banner">
        通知
      </div>
      <Spin spinning={loading}>
        <div className="content-width">
          <div className="policy-list__filter">
            <FilterType
              title="级别"
              radio
              titleWidth={60}
              data={dict[POLICY_LEVEL]}
              onChange={(e) => handleFilter(e, 'moduleType')}
            />
          </div>
          {
            isEmpty(data?.items) ? (
              <EmptyImg height={300} />
            ) : (
              <div className="zczx__con">
                {
                  data?.items?.map((item) => (
                    <div key={item.id} className="zczx__con-li" onClick={() => handleChange(item.id)}>
                      <div className="zczx__con-li-time">
                        <div>{getData(item.gmtPublish, 'day')}</div>
                        <div>{getData(item.gmtPublish)}</div>
                      </div>
                      <div className="zczx__con-r">
                        <div className="zczx__con-li-title">
                          <span>{item?.title}</span>
                          <span className={policyType[item.module]?.class}>{policyType[item.module]?.name}</span>
                        </div>
                        <div className="zczx__con-li-text">{item.content.replace(/<\/?[^>]*>|[ ]|[&nbsp;]/g, '')}</div>
                      </div>
                    </div>
                  ))
                }
                <div className="pagination-box">
                  <Pagination
                    showQuickJumper
                    defaultCurrent={data?.pageNum}
                    total={data?.totalRows}
                    onChange={onPageChange}
                  />
                </div>
              </div>
            )
          }
        </div>
      </Spin>
      <FixMenu />
    </div>
  );
}
